import { combineQueries, createEntityQuery, Order } from '@datorama/akita';
import { distinctUntilChanged, map } from 'rxjs';
import store from './store';
import { type Feature } from 'types/models';

export const query = createEntityQuery(store, {
   sortBy: 'name',
   sortByOrder: Order.ASC,
});
export const entities$ = query.selectAll();
export const loading$ = query.selectLoading();

export const isAiActive$ = combineQueries([entities$, loading$]).pipe(
   map(([features, isLoading]) => !isLoading && features.some(({ name, active }) => name === 'AI' && active)),
   distinctUntilChanged()
);
export const isStatusFeatureActive$ = query.selectAll({ filterBy: [(entity: Feature) => entity.name === 'Status', ({ active }) => !!active] }).pipe(
   map((features) => features.length > 0),
   distinctUntilChanged()
);
